// The shared customer status pill.
//
// ⛔ WHY THIS LIVES IN ITS OWN FILE AND MUST NOT GO BACK INTO theme.js:
// it returns JSX, and theme.js is a `.js` file imported by `src/lib/*.js`
// modules that the 46 verification harnesses load under PLAIN NODE with no
// Babel. JSX in a `.js` module is a SyntaxError at module-parse time, so from
// 20 Oct to 22 Oct 2026 the StatusBadge that used to sit at theme.js:55-58 made
// twelve lib modules unimportable and killed 25 of the 46 harnesses outright —
// they died in 0.2s having executed zero assertions.
//
// ⚠️ `node --check` does NOT catch this: it exits 0 on the file while
// `await import()` fails at the same line. A design-tokens module must stay
// importable by anything, which means it exports values and never a component.
import { C, S } from "./theme";

export function StatusBadge({ status }) {
  const bg = status === "active" ? C.success : C.textDim;
  return <span style={S.pill(bg)}>{status || "—"}</span>;
}
